export default __webpack_public_path__ + "static/pic2-6dc74a3a8d6efb33343e79e43e2e2a65.jpeg";